module.exports = __webpack_public_path__ + "media/images/countrysquared/mx-6db71f0c699e7ed2a1476e14d2f63226.svg";